import { styled, Typography } from '@mui/material';

const PageTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h4.fontSize,
  fontWeight: theme.typography.h4.fontWeight,
  lineHeight: theme.typography.h4.lineHeight,
  color: (theme.vars || theme).palette.text.primary,
}));

export { PageTitle };
